<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon" [class.cf-dlg-icon--blue]="!isDisposicion">
      <mat-icon>{{ isDisposicion ? 'payment' : 'account_balance_wallet' }}</mat-icon>
    </div>
    <div class="mtc-header-text">
      <h2 class="cf-dlg-title">{{ isDisposicion ? 'Disposiciones' : 'Liquidaciones' }} de la tarjeta</h2>
      <p class="cf-dlg-subtitle" *ngIf="cardSubtitle">{{ cardSubtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando movimientos…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="'Guardando ' + tittle.toLowerCase() + '…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="mtc-empty mtc-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los movimientos.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body mtc-body">
      <section class="mtc-section">
        <span class="cf-dlg-section__label mtc-section__label">
          {{ isEditMode ? 'Editar ' + tittle.toLowerCase() : 'Nueva ' + tittle.toLowerCase() }}
          <button *ngIf="isEditMode" type="button" class="mtc-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <div class="mtc-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingFecha">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingFecha"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required mtc-grid__wide" [class.cf-field--invalid]="submitted && missingConcepto">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100, hint: conceptoLength + '/100' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcepto"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidImporte">
            <app-field [control]="control('importe')" [config]="{ label: 'Importe', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidImporte"><mat-icon>error</mat-icon> Indica un importe distinto de 0</div>
          </div>

          <div [class.cf-field--invalid]="submitted && invalidComisiones">
            <app-field [control]="control('comisiones')" [config]="{ label: 'Comisiones', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidComisiones"><mat-icon>error</mat-icon> Indica las comisiones</div>
          </div>

          <div [class.cf-field--invalid]="submitted && invalidIntereses">
            <app-field [control]="control('intereses')" [config]="{ label: 'Intereses', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidIntereses"><mat-icon>error</mat-icon> Indica los intereses</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>

          <div *ngIf="isProjectEnable && projects.length > 0">
            <app-autocomplete [control]="control('project')" [config]="{ label: 'Proyecto', placeholder: 'Sin proyecto', options: projects, strict: true }">
            </app-autocomplete>
          </div>

          <div *ngIf="isProjectEnable && expenseProjectTypes.length > 0">
            <app-autocomplete [control]="control('expenseProjectType')" [config]="{ label: 'Tipo de proyecto de gasto', placeholder: 'Sin tipo', options: expenseProjectTypes, strict: true }">
            </app-autocomplete>
          </div>
        </div>
      </section>

      <section class="mtc-section">
        <span class="cf-dlg-section__label mtc-section__label">
          {{ isDisposicion ? 'Disposiciones' : 'Liquidaciones' }} del ejercicio {{ year }}
          <span class="mtc-section__total" *ngIf="dataSource.length">{{ dataSource.length }} · {{ totalImporte | number:'1.2-2' }} €</span>
        </span>

        <app-loading-state *ngIf="listLoading" [compact]="true" message="Actualizando movimientos…"></app-loading-state>

        <ng-container *ngIf="!listLoading">
          <div class="mtc-empty" *ngIf="!dataSource.length">
            <mat-icon>info</mat-icon>
            <span>Todavía no hay {{ isDisposicion ? 'disposiciones' : 'liquidaciones' }} en este ejercicio.</span>
          </div>

          <div class="mtc-rows" *ngIf="dataSource.length">
            <div class="mtc-row" *ngFor="let item of dataSource; trackBy: trackByUid"
              [class.mtc-row--editing]="isEditMode && editingUid === item.uid">
              <div class="mtc-row__date">{{ item.fecha | date:'dd/MM/yyyy' }}</div>
              <div class="mtc-row__main">
                <div class="mtc-row__concept" [title]="item.concepto">{{ item.concepto || 'Sin concepto' }}</div>
                <div class="mtc-row__meta">
                  {{ item.activitiesName }}{{ item.cuentaBancariaAsociadaInfo ? ' · ' + item.cuentaBancariaAsociadaInfo : '' }}{{ item.comisiones ? ' · Comisiones ' + (item.comisiones | number:'1.2-2') + ' €' : '' }}{{ item.intereses ? ' · Intereses ' + (item.intereses | number:'1.2-2') + ' €' : '' }}
                </div>
              </div>
              <div class="mtc-row__amount">{{ item.importe | number:'1.2-2' }} €</div>
              <div class="mtc-row__actions">
                <button type="button" mat-icon-button class="mtc-row__btn" (click)="edit(item)" title="Editar" aria-label="Editar movimiento">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-icon-button class="mtc-row__btn mtc-row__btn--danger" (click)="delete(item)" title="Eliminar" aria-label="Eliminar movimiento">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </section>
    </div>

    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
        {{ isEditMode ? 'Guardar cambios' : 'Añadir ' + tittle.toLowerCase() }}
      </button>
    </div>
  </ng-container>
</div>
